import React from 'react'

import Layout from '../components/layout'
import About from '../components/about'

const AboutPage = () => (
  <Layout seo={{ title: 'Sobre mí' }}>
    <About />
  </Layout>
)

export default AboutPage
